export default __webpack_public_path__ + "static/subset-Aeroport-Bold-321f8aaee654dc271feb7a9aa1d105bf.woff";